/**
 * Available functional checks result
 */
export enum FunctionalCheck {
    OK = 'ok',
    NOT_OK = 'not-ok',
    NOT_APPLICABLE = 'not-applicable',
}
// Todo: talk about this values and true/false/null in prophylaxis and come to unified solution
